<script>
import WishlistPanel from '@phoenix/mixins/components/wishlist/WishlistPanel';
import SharedWishlistButton from '@maison/components/wishlist/SharedWishlistButton.vue';
import Panel from '../common/Panel';
import ProductCard from '../product/ProductCard.vue';
import ProductPrice from '@phoenix/components/common/ProductPrice';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  components: { ProductCard, ProductPrice, Panel, SharedWishlistButton },

  mixins: [WishlistPanel],

  computed: {
    isMyAccountActivated() {
      return getFeatureFlag(FEATURE_FLAG.MY_ACCOUNT);
    },
  },
};
</script>

<template>
  <panel
    id="wishlist-panel"
    :classes="['wishlist-panel', 'panel--reverse']"
    reverse
    :title="$t('Wishlist.wishlistTitle')"
    :options="panelOptions"
  >
    <template v-if="isShownAndLoaded" #content>
      <template v-if="products.length > 0">
        <ul class="list list--stacked list--md" data-cy="wishlist-panel-products">
          <li v-for="product in products" :key="product.modelReference" data-cy="wishlist-panel-products-item">
            <ProductCard
              v-bind="product"
              :reference="product.modelReference"
              :sap-reference="product.sapReference"
              :reference-text="product.referenceText"
              :labels="product.labels"
              :image="product.imageProductKey"
              :vat-information="vatInformation(product.price)"
              :should-display-add-to-wishlist="true"
              :show-tags="false"
              :tight="true"
              :horizontal="true"
              :show-reference="true"
              :show-vat="false"
              :lazy="false"
              default-in-wishlist-icon="close"
              small-price
              :should-display-price="false"
            >
              <template #price>
                <product-price v-bind="localizePrice(product.price)"></product-price>
              </template>
            </ProductCard>
          </li>
        </ul>

        <hr class="divider" />

        <div class="wishlist-panel__create-account-section">
          <h4>{{ $t('SharedWishlist.title') }}</h4>
          <small class="wishlist-panel__create-account-section-infos">
            {{ $t('SharedWishlist.explanationText') }}
          </small>

          <div class="panel__actions">
            <shared-wishlist-button />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="uppercase">
          {{ $t('Wishlist.emptyWishlist') }}
        </div>
      </template>

      <template v-if="isMyAccountActivated && !isLogged">
        <hr class="divider" />

        <div class="wishlist-panel__create-account-section">
          <h4>{{ $t('MyAccount.orCreateANewOne') }}</h4>
          <small class="wishlist-panel__create-account-section-infos">
            {{ $t('MyAccount.orCreateANewOneText') }}
          </small>

          <div class="panel__actions">
            <a :href="menuLinks.guestLinks.accountCreate" class="btn btn--secondary" data-panel-close="wishlist-panel">
              <span class="btn__text">{{ $t('MyAccount.createMyAccount') }}</span>
            </a>
          </div>
        </div>
      </template>

      <div v-if="isLoading" class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark loader--lg">
          <div class="loader__inner"></div>
        </div>
      </div>
    </template>
    <template v-else #content>
      <div class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark loader--lg">
          <div class="loader__inner"></div>
        </div>
      </div>
    </template>
  </panel>
</template>
